{
  "nav": {
    "label": "Главное меню",
    "reservoirs": "Водохранилища",
    "noTenants": "Нет доступных водохранилищ",
    "organizations": "Организации",
    "settings": "Настройки",
    "interfaceSettings": "Настройки интерфейса",
    "hotkeys": "Горячие клавиши",
    "guide": "Руководство пользователя",
    "collapse": "Свернуть меню",
    "expand": "Развернуть меню",
    "expandItem": "{{name}} — развернуть",
    "collapseItem": "{{name}} — свернуть",
    "groups": {
      "devices": "Управление устройствами",
      "monitoring": "Мониторинг",
      "employees": "Сотрудники",
      "connectors": "Коннекторы",
      "documents": "Документы",
      "alarms": "Критерии",
      "constructor": "Конструктор"
    },
    "items": {
      "deviceConfig": "Конфигурация устройств",
      "deviceCategories": "Категории устройств",
      "deviceLocations": "Места установки",
      "deviceInfo": "Сведения об устройствах",
      "deviceCalibration": "Калибровка устройств",
      "charts": "Управление графиками",
      "monitoringDevices": "Данные устройств",
      "monitoringPhysical": "Физические показатели",
      "monitoringVirtual": "Виртуальные показатели",
      "employees": "Управление сотрудниками",
      "connectors": "Управление коннекторами",
      "documents": "Документы",
      "alarms": "Мониторинг критериев",
      "dashboard": "Главная панель"
    }
  },
  "tabs": {
    "label": "Открытые страницы",
    "home": "Главная панель",
    "dashboardEdit": "Настройка главной панели",
    "sectionEdit": "Настройка раздела",
    "section": "Раздел",
    "devices": "Конфигурация устройств",
    "charts": "Управление графиками",
    "monitoring": "Мониторинг данных",
    "employees": "Управление сотрудниками",
    "connectors": "Управление коннекторами",
    "documents": "Документы",
    "alarms": "Мониторинг критериев",
    "settings": "Настройки",
    "guide": "Руководство пользователя",
    "admin": "Организации",
    "pin": "Закрепить",
    "unpin": "Открепить",
    "close": "Закрыть",
    "unsaved": "Есть несохранённые изменения",
    "scrollLeft": "Предыдущие вкладки",
    "scrollRight": "Следующие вкладки",
    "confirmClose": {
      "title": "Изменения не сохранены",
      "text": "Если закрыть «{{title}}», введённые данные будут потеряны.",
      "stay": "Остаться",
      "close": "Закрыть"
    }
  },
  "pages": {
    "dashboardEdit": "Настройка главной панели",
    "sectionEdit": "Настройка раздела",
    "deviceConfig": "Конфигурация устройств",
    "deviceCategories": "Категории устройств",
    "deviceLocations": "Места установки устройств",
    "deviceInfo": "Сведения об устройствах",
    "deviceCalibration": "Калибровка устройств",
    "charts": "Управление графиками",
    "monitoringDevices": "Данные устройств",
    "monitoringPhysical": "Мониторинг физических показателей",
    "monitoringVirtual": "Мониторинг виртуальных показателей",
    "employees": "Управление сотрудниками",
    "connectors": "Управление коннекторами",
    "documents": "Документы",
    "alarms": "Мониторинг критериев",
    "settings": "Настройки",
    "interfaceSettings": "Настройки интерфейса",
    "hotkeys": "Горячие клавиши",
    "guide": "Руководство пользователя",
    "admin": "Организации и водохранилища"
  },
  "comingSoon": {
    "hint": "Эта страница в разработке и скоро станет доступна."
  },
  "noAccess": {
    "title": "Нет доступа",
    "hint": "У вас нет прав на просмотр этой страницы. Обратитесь к администратору."
  },
  "user": {
    "menu": "Меню пользователя",
    "settings": "Настройки",
    "logout": "Выйти",
    "roles": {
      "platform_admin": "Главный администратор",
      "org_admin": "Администратор организации",
      "tenant_admin": "Администратор водохранилища",
      "tenant_member": "Сотрудник"
    }
  }
}
